import { render, staticRenderFns } from "./DownloadCell.vue?vue&type=template&id=1d79977a&scoped=true"
import script from "./DownloadCell.vue?vue&type=script&lang=js"
export * from "./DownloadCell.vue?vue&type=script&lang=js"
import style0 from "./DownloadCell.vue?vue&type=style&index=0&id=1d79977a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d79977a",
  null
  
)

export default component.exports